const part = [
    {
        path: 'serial-list',
        name: 'serial-list',
        meta: {
            icon: 'md-cube',
            title: '系列管理',
            notCache: true,
            access: ['B', 'C', 'S'],
            items: [
            ]
        },
        component: () => import('@/view/product-management/serial-management/serial-list')
    }
];

export default part;
